import logo from "./assets/schmidt/logo.svg";
import background from "../../assets/background_.jpg";

/**
 * Schmidt — first customer skin. Validates the skinning seam: recolour to blue
 * (#4A78BC) with navy (#1B2C45) at the dark end, a different logo, and a
 * reduced sidebar for the policyholder-facing product. This file is the ONLY
 * thing that changes for the Schmidt skin — no component code is touched.
 */
export default {
  id: "schmidt",
  name: "Schmidt",
  productName: "Schadenportal",

  // Footer: "<product> | Version x | <company>".
  footer: {
    productName: "Schmidt Schadenportal",
    companyName: "Versicherungsmakler Schmidt GmbH",
  },

  palette: {
    // Navy is pinned at the dark end so headings / deep surfaces match the dummy.
    primary: { seed: "#4A78BC", anchor: 700, overrides: { 900: "#1B2C45" } },
    secondary: { seed: "#4A78BC", anchor: 600, overrides: { 900: "#1B2C45" } },
  },

  // Schmidt's dark sidebar surface uses its navy.
  sidebar: { background: "#1B2C45" },

  // Contact block — drives the "Kontakt" modal. TODO: real Schmidt phone/email.
  contact: {
    label: "Versicherungsmakler Schmidt GmbH",
    name: "",
    funktion: "Zentrale",
    telefon: "",
    fax: "",
    email: "",
  },

  // Short labels used inline in tables / claim detail.
  labels: {
    tenantName: "Schmidt",
    short: "Schmidt",
  },

  // `auth` omitted on purpose → inherits the generic login copy.
  // `typography` omitted → default Inter face.

  assets: {
    logo,
    logoAlt: "Schmidt Logo",
    background,
    // No `favicon` here on purpose: a skin may omit it, leaving the default.
  },

  // Reduced, policyholder-facing navigation.
  features: {
    showSidebarTitle: true,
    help: true,
    // Demonstrates the skinning hook — Schmidt shows the user only in the sidebar.
    userDisplay: "sidebar",
    // Two-phase customer→broker claim-report flow (see JourneyWizard/PhaseRail).
    claimWizardFlow: "customer",
    nav: {
      claims: true,
      contracts: true,
      mail: true,
      customers: true,
      insurers: true,
      objects: true,
      controlling: true,
      users: true,
      substitutions: true,
      reminders: true,
      bookings: true,
    },
  },
};
